import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '../material/material.module';
import { HowToSplitPdfDialogComponent } from './how-to-split-pdf-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false })
    ],
    declarations: [HowToSplitPdfDialogComponent],
    exports: [HowToSplitPdfDialogComponent]
})
export class HowToSplitPdfDialogModule {}
